import { deleteOrganisationUser } from '@infuse/api/iam/organisation';
import { useGenericDeleteUser } from '@infuse/iam/user/mutations';

export const useDeleteOrganisationUser = () =>
  useGenericDeleteUser({
    apiFn: deleteOrganisationUser
  });
